import React, { useState } from 'react';

const CopyField = ({ value, label }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard?.writeText(value).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        });
    };

    return (
        <button
            type="button"
            className="hk-copy-btn"
            onClick={handleCopy}
            title={`Kopírovat ${label}`}
        >
            <span className="fw-bold">{value}</span>
            <i className={`bi ${copied ? 'bi-check2' : 'bi-clipboard'} ms-2`}></i>
            {copied && <span className="hk-copy-tooltip">Zkopírováno</span>}
        </button>
    );
};

const Contact = () => {
    return (
        <div className="container my-5 py-4 bg-dark text-light rounded shadow-lg hk-contact-card">
            <h1 className="text-center mb-4 text-uppercase border-bottom pb-3">
                <i className="bi bi-chat"></i> Kontakt
            </h1>

            {/* Rychlé akce */}
            <div className="d-flex justify-content-center flex-wrap gap-3 mb-4">
                <a href="mailto:hugoknives@email.cz" className="hk-icon-btn" title="Napsat email">
                    <i className="bi bi-envelope-fill"></i>
                </a>
                <a href="http://m.me/petr.dolezal.31" className="hk-icon-btn" title="Messenger" target="_blank" rel="noreferrer">
                    <i className="bi bi-messenger"></i>
                </a>
                <a
                    href="https://www.facebook.com/profile.php?id=100042132956763"
                    className="hk-icon-btn"
                    title="Facebook"
                    target="_blank"
                    rel="noreferrer"
                >
                    <i className="bi bi-facebook"></i>
                </a>
                <a
                    href="https://x.com/KnivesHugo"
                    className="hk-icon-btn"
                    title="X"
                    target="_blank"
                    rel="noreferrer"
                >
                    <i className="bi bi-twitter-x"></i>
                </a>
            </div>

            <div className="row g-4">
                <div className="col-md-6">
                    <div className="hk-info-block h-100">
                        <h4 className="text-uppercase mb-3">
                            <i className="bi bi-person-circle me-2"></i> Osobní údaje
                        </h4>
                        <p>
                            <i className="bi bi-person me-2"></i> <strong>Jméno:</strong> Petr Doležal
                        </p>
                        <p>
                            <i className="bi bi-house me-2"></i> <strong>Adresa:</strong><br />
                            Kostníky 41<br />
                            p. Třebelovice<br />
                            675 32
                        </p>
                        <p className="mb-0">
                            <i className="bi bi-building me-2"></i> <strong>IČO:</strong> 07233299
                        </p>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="hk-info-block h-100">
                        <h4 className="text-uppercase mb-3">
                            <i className="bi bi-envelope-paper me-2"></i> Kontakt
                        </h4>
                        <p>
                            <i className="bi bi-envelope me-2"></i> <strong>Email:</strong>{' '}
                            <a href="mailto:hugoknives@email.cz" className="text-info text-decoration-none">
                                hugoknives@email.cz
                            </a>
                        </p>
                        <p>
                            <i className="bi bi-messenger me-2"></i> <strong>Messenger:</strong>{' '}
                            <a href="http://m.me/petr.dolezal.31" className="text-info text-decoration-none">
                                Přejít
                            </a>
                        </p>
                        <p>
                            <i className="bi bi-facebook me-2"></i> <strong>Facebook:</strong>{' '}
                            <a
                                href="https://www.facebook.com/profile.php?id=100042132956763"
                                className="text-info text-decoration-none"
                            >
                                Přejít
                            </a>
                        </p>
                        <p className="mb-0">
                            <i className="bi bi-twitter-x me-2"></i> <strong>X.com:</strong>{' '}
                            <a
                                href="https://x.com/KnivesHugo"
                                className="text-info text-decoration-none"
                            >
                                Přejít
                            </a>
                        </p>
                    </div>
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-12">
                    <div className="hk-info-block">
                        <h4 className="text-uppercase mb-3">
                            <i className="bi bi-bank me-2"></i> Bankovní spojení
                        </h4>
                        <p className="mb-0">
                            <i className="bi bi-credit-card me-2"></i> <strong>Číslo účtu:</strong>{' '}
                            <CopyField value="115-8605030217/0100" label="číslo účtu" />
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
